export default "<p>\n  issue-proformables-card works!\n</p>\n";